module.exports = [
	{
		"componentChunkName": "component---src-templates-doc-page-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "docs-android.json",
		"path": "/docs/android"
	},
	{
		"componentChunkName": "component---src-templates-doc-page-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "test.json",
		"path": "/test"
	},
	{
		"componentChunkName": "component---src-templates-doc-page-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "docs-cli.json",
		"path": "/docs/cli"
	},
	{
		"componentChunkName": "component---src-templates-doc-page-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "docs-context.json",
		"path": "/docs/context"
	},
	{
		"componentChunkName": "component---src-templates-doc-page-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "docs.json",
		"path": "/docs"
	},
	{
		"componentChunkName": "component---src-templates-doc-page-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "docs-install.json",
		"path": "/docs/install"
	},
	{
		"componentChunkName": "component---src-templates-doc-page-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "docs-tools.json",
		"path": "/docs/tools"
	},
	{
		"componentChunkName": "component---src-templates-doc-page-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "docs-webpack.json",
		"path": "/docs/webpack"
	},
	{
		"componentChunkName": "component---src-pages-contact-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "contact.json",
		"path": "/contact/"
	},
	{
		"componentChunkName": "component---src-pages-index-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "index.json",
		"path": "/"
	},
	{
		"componentChunkName": "component---src-pages-android-index-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "android.json",
		"path": "/android/"
	},
	{
		"componentChunkName": "component---src-pages-index-feature-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "index-feature.json",
		"path": "/index/Feature/"
	},
	{
		"componentChunkName": "component---src-pages-index-index-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "index.json",
		"path": "/index/"
	},
	{
		"componentChunkName": "component---src-pages-pricing-index-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "pricing.json",
		"path": "/pricing/"
	},
	{
		"componentChunkName": "component---src-templates-privacy-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-js",
		"jsonName": "privacy.json",
		"path": "/privacy"
	}
];


//////////////////
// WEBPACK FOOTER
// ./.cache/pages.json
// module id = ./.cache/pages.json
// module chunks = 15178676390636814000